/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: prop-types library.
import { useApolloClient } from '@apollo/client' // Npm: Apollo client.


/*
 * PACKAGES
 */
import InfiniteScrollSelector from 'components/InfiniteScrollSelector'


/*
 * GRAPHS
 */
import VendorAccountOptionsQuery from './__query__/index.vendorAccount.options.query'


/*
 * HELPERS
 */
const _GetOptionLabel = option => option.displayName
const _GetSelectedLabel = value => {
  const _IdStart = value.lastIndexOf(' (')

  return 0 < _IdStart ? value.slice(0, _IdStart) : value
}


/*
 * OBJECTS
 */
const Index = props => {
  // Hook assignment.
  const _Client = useApolloClient()

  // Fetch a lightweight vendor-account options page.
  const _LoadOptions = React.useCallback(async (variables, signal) => {
    const _Result = await _Client.query({
      'query': VendorAccountOptionsQuery,
      variables,
      // The shared selector owns a bounded cache.
      'fetchPolicy': 'no-cache',
      'context': { 'fetchOptions': { signal } }
    })

    if (_Result.errors?.length) throw new Error(_Result.errors[0].message)
    return _Result.data?.VendorAccountOptions ?? []
  }, [_Client])

  // Return component.
  return (
    <InfiniteScrollSelector
      {...props}
      loadOptions={_LoadOptions}
      ariaLabel='Vendor accounts'
      searchPlaceholder='Search vendor accounts'
      emptyMessage='No vendor accounts found.'
      getOptionLabel={_GetOptionLabel}
      getSelectedLabel={_GetSelectedLabel} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'name': PropTypes.string.isRequired,
  'label': PropTypes.string,
  'value': PropTypes.string,
  'data': PropTypes.string,
  'onChange': PropTypes.func.isRequired,
  'disabled': PropTypes.bool,
  'isRequired': PropTypes.bool,
  'isInvalid': PropTypes.bool,
  'error': PropTypes.string,
  'placeholder': PropTypes.string,
  'height': PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}


/*
 * EXPORT
 */
export default React.memo(Index)
